import { IconProps } from './icons-props';

function ArchiveMinusIcon({ className, width = 21, height = 20 }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 21 20'
            fill='none'
            className={className}
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M8.6665 8.75H12.8335C12.8635 8.75009 12.8949 8.76253 12.9204 8.78809C12.9459 8.8137 12.9585 8.84492 12.9585 8.875C12.9585 8.90508 12.9459 8.9363 12.9204 8.96191C12.8949 8.98747 12.8635 8.99991 12.8335 9H8.6665C8.63636 9 8.60523 8.98756 8.57959 8.96191C8.55395 8.93627 8.5415 8.90515 8.5415 8.875C8.5415 8.84485 8.55395 8.81373 8.57959 8.78809C8.60523 8.76244 8.63636 8.75 8.6665 8.75Z'
                fill='currentColor'
                stroke='currentColor'
            />
            <path
                d='M6.7251 1.5415H14.7671C16.6074 1.54175 18.1079 3.04293 18.1079 4.8833V16.6245C18.1079 17.4446 17.7931 18.0078 17.3481 18.2681C16.9549 18.4979 16.4091 18.53 15.7993 18.2681L15.5347 18.1382L11.4673 15.8794L11.4663 15.8784C11.2433 15.7555 10.9695 15.7163 10.7456 15.7163C10.5216 15.7163 10.2479 15.7554 10.0249 15.8784L10.0239 15.8794L5.95752 18.1382C5.56538 18.356 5.18928 18.4585 4.85791 18.4585C4.59018 18.4584 4.35103 18.395 4.13916 18.2739C3.69647 18.0126 3.38333 17.4506 3.3833 16.6333V4.8833C3.3833 3.04278 4.88457 1.5415 6.7251 1.5415ZM6.73291 1.7915C5.03195 1.79172 3.64209 3.18229 3.64209 4.8833V16.6245C3.64209 17.1606 3.79023 17.7775 4.28662 18.0591C4.77037 18.3421 5.37036 18.1859 5.84131 17.9194L5.84229 17.9204L9.90771 15.6616L9.90869 15.6626C10.1286 15.5408 10.4291 15.4683 10.7495 15.4683C11.0701 15.4683 11.3713 15.5407 11.5913 15.6626V15.6616L15.6567 17.9194C16.1312 18.1883 16.7381 18.3448 17.2241 18.0532C17.7063 17.7637 17.8579 17.1602 17.8579 16.6245V4.8833C17.8579 3.18231 16.468 1.79175 14.7671 1.7915H6.73291Z'
                fill='currentColor'
                stroke='currentColor'
            />
        </svg>
    );
}

export default ArchiveMinusIcon;

